<template>
    <v-dialog :value="value" persistent max-width="650px">
        <v-card class="overflow-x-hidden">
            <v-card-title>
                Terms of Use & Privacy Policy Agreement
            </v-card-title>
            <v-card-text>
                <p>
                    By proceeding, you acknowledge that you have read, understood, and agree to the <a
                        href="https://allianceretailgroup.com/terms-of-use" target="_blank">Terms of Use</a> and <a
                        href="https://allianceretailgroup.com/privacy" target="_blank">Privacy Policy</a> governing the use of this
                    application. These policies outline your rights and obligations as a user, including how we handle
                    your data and ensure your privacy.
                </p>
            </v-card-text>
            <v-card-actions>
                <v-col>
                    <v-row align="center">
                        <v-btn :style="styleObject" @click.prevent="logout">
                            <v-icon color="#fff" class="mr-2">mdi-logout</v-icon>
                            <span>Logout</span>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-checkbox v-model="isAccepted" label="Accept Terms & Conditions"></v-checkbox>
                        <v-btn @click.prevent="update" :disabled="!isAccepted" color="primary" class="ml-8">
                            <span>Confirm</span>
                        </v-btn>
                    </v-row>
                </v-col>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>

export default {
  name: 'TermsAndConditionsModal',
  props: ['value'],
  data() {
    return {
      isAccepted: false,
      styleObject: {
        background: '#E53935',
        color: 'white',
        fontSize: '15px'
      },
    }
  },
  methods: {
    update() {
      this.$emit('update')
    },
    logout() {
      this.$emit('logout')
    }
  }
}
</script>
